import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import MixinGame from '@/mixins/game'
import Auth from '@services/auth'

@Component
export default class Players extends mixins(MixinGame) {
  public table: any = {}

  @Watch('activeSeatID')
  public onActiveSeatIDChanged() {
    this.updateYourTurn()
  }

  public updateYourTurn() {
    this.setYourTurn(this.table.seats[this.activeSeatID].player.key === Auth.userKey)
  }

  public init() {
    this.table.seats.forEach((seat: any, index: number) => {
      const player = this.players[index]
      player.name = seat.player.name
    })

    this.updateYourTurn()
  }

  public async created() {
    this.table = await this.$feathers.service('/api/tables').get(this.tableID)
    this.init()
  }

  private getTypeIndicator(type: string) {
    return type === 'build_up' ? '↑' : '↓'
  }
}
